import script from "./RecipeBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./RecipeBlock.vue?vue&type=script&setup=true&lang=js"

import "./RecipeBlock.vue?vue&type=style&index=0&id=2508a288&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2508a288"]])

export default __exports__